import { ui } from '@joint/plus';
import { IconButton } from '../components/IconButton.js';
import { DEFAULTS } from './config.js';

const ZOOM_STORAGE_KEY = 'map_zoom_level';

export function initToolbar(scroller) {
  const savedZoom = localStorage.getItem(ZOOM_STORAGE_KEY);
  const initialZoom = savedZoom ? Math.round(parseFloat(savedZoom) * 100) : 100;

  const toolbar = new ui.Toolbar({
    autoToggle: false,
    references: { paperScroller: scroller },
    tools: [
      { type: 'icon-button', name: 'fullscreen', icon: 'fullscreen' },
      {
        type: 'zoom-slider',
        min: DEFAULTS.toolbar.zoomMin,
        max: DEFAULTS.toolbar.zoomMax,
        step: DEFAULTS.toolbar.zoomStep,
        value: initialZoom,
        attrs: { input: { 'data-tooltip': 'Faire glisser pour zoomer' } },
      },
      { type: 'separator' },
      { type: 'icon-button', name: 'zoom-out-min', icon: 'zoom-out-min', tooltip: 'Zoom out to minimum' },
      { type: 'separator' },
      { type: 'icon-button', name: 'minimap', icon: 'minimap' },
    ],
    widgetNamespace: { ...ui.widgets, iconButton: IconButton },
  });

  toolbar.render();
  return toolbar;
}
